<template>
  <div v-if="isEditable">
    <h2 class="section-heading-name">
      Extra navigationsblock
    </h2>
    <div
      v-edit="'AdditionalNavigatablePages'"
      class="extra-navigation-blocks"
    >
      <navigation-block
        v-for="item in items"
        :key="'additionalNavigatablePages--' + item.contentId"
        v-bind="item"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default () { return [] }
    }
  }
}
</script>

<style lang="scss">
.extra-navigation-blocks {
  margin-bottom: 2rem;
  min-height: 4rem;
}
</style>
